import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useCollection } from "../lib/useCollection";

const reviews = [
    {
        id: "review-1",
        name: "Rahul Mehta",
        business: "Mehta Sweets, Pune",
        text: "Our new logo and glow sign brought a clear lift in walk‑ins. Raj's team was patient with revisions and finished on time.",
    },
    {
        id: "review-2",
        name: "Anita Verma",
        business: "Bloom Boutique",
        text: "From packaging to social media creatives — everything looks like it belongs together. The brand finally feels premium.",
    },
    {
        id: "review-3",
        name: "Sundeep Patil",
        business: "Patil Auto Care",
        text: "Sharp signage, fast delivery, fair price. They handled the whole shopfront branding without me chasing anyone.",
    },
];

export const Testimonials = () => {
    const items = useCollection("/testimonials", reviews);
    return (
        <section
            data-testid="testimonials-section"
            className="relative py-24 sm:py-32 bg-[#080808] border-t border-white/5"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.6 }}
                    className="max-w-2xl mb-14"
                >
                    <div className="font-inter text-xs uppercase tracking-[0.25em] text-gold mb-4">
                        Client Stories
                    </div>
                    <h2 className="font-poppins font-semibold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl">
                        Loved by founders & local businesses.
                    </h2>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
                    {items.map((r, i) => (
                        <motion.div
                            key={r.id || `${r.name}-${i}`}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.2 }}
                            transition={{ duration: 0.6, delay: i * 0.08 }}
                            data-testid={`testimonial-card-${r.id || i}`}
                            className="relative bg-[#0c0c0c] border border-white/5 rounded-2xl p-7 hover:border-gold/30 transition-colors"
                        >
                            <Quote
                                size={28}
                                className="text-gold/30 absolute top-6 right-6"
                                strokeWidth={1.5}
                            />
                            <div className="flex items-center gap-1 mb-5">
                                {Array.from({ length: r.rating || 5 }).map((_, idx) => (
                                    <Star
                                        key={idx}
                                        size={14}
                                        className="text-gold fill-gold"
                                        strokeWidth={1.5}
                                    />
                                ))}
                            </div>
                            <p className="font-inter text-zinc-300 leading-relaxed">
                                {r.text}
                            </p>
                            <div className="mt-7 pt-5 border-t border-white/5">
                                <div className="font-poppins font-medium text-white">
                                    {r.name}
                                </div>
                                <div className="font-inter text-sm text-zinc-500">
                                    {r.business}
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
